import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SnackBarService } from '../services/snack-bar.service';
import { AuthService } from '../services/auth.service';
import { IUser } from '../../auth/models/auth.model';

/**
 * OnboardingDataGuard
 *
 * Route guard to ensure onboarding data exists before allowing access to tax-assessment route.
 * Redirects to individual-onboarding if data is missing.
 */
export const OnboardingDataGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const getUserDetail = (): IUser | null => {
    return authService.getUserProfileData();
  };

  const snackBarService = inject(SnackBarService);

  if (getUserDetail()?.onboardingStatus === 'COMPLETED') {
    return true;
  }

  if (getUserDetail()?.onboardingStatus === 'INCOMPLETED') {
    snackBarService.openSnackBar('Please complete the previous step first.', 'error');
    router.navigateByUrl('/clients/individual-onboarding');
    return false;
  }

  return true;
};
